import type { MapBounds } from '@/shared/map';
import type { ProductsSearch } from './search-params';

// Search patches written when the map drives the URL. The two geo filters
// (viewport bbox and custom region) are mutually exclusive, so each patch
// clears the other; both reset pagination. Fed to `mergeSearch`.

export const boundsToSearchPatch = (
  bounds: MapBounds
): Partial<ProductsSearch> => ({
  neLat: bounds.northEastLat,
  neLng: bounds.northEastLng,
  swLat: bounds.southWestLat,
  swLng: bounds.southWestLng,
  regionId: undefined,
  page: undefined,
});

export const regionToSearchPatch = (
  regionId: string | null
): Partial<ProductsSearch> => ({
  regionId: regionId ?? undefined,
  neLat: undefined,
  neLng: undefined,
  swLat: undefined,
  swLng: undefined,
  page: undefined,
});

// "Reset all filters" patch: clears every product filter — table filters,
// sort, AND the map's geo filters (viewport bbox + custom region). Fed to
// `mergeSearch`, which drops the `undefined` keys from the URL. Keep this in
// sync with the `ProductsSearch` filter fields so Reset leaves nothing behind
// (the map bbox/region in particular — see boundsToSearchPatch above).
export const clearAllSearchPatch = (): Partial<ProductsSearch> => ({
  search: undefined,
  city: undefined,
  supplierName: undefined,
  contentCategory: undefined,
  contentSubcategory: undefined,
  catalogId: undefined,
  country: undefined,
  valueTier: undefined,
  visibility: undefined,
  cmsVisibility: undefined,
  miniPlannerVisibility: undefined,
  sortBy: undefined,
  sortOrder: undefined,
  regionId: undefined,
  neLat: undefined,
  neLng: undefined,
  swLat: undefined,
  swLng: undefined,
  page: undefined,
});
